import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    },
    {
      path: '/investment',
      name: 'investment',
      component: () => import('./views/Invest.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/Contact.vue')
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('./views/News.vue')
    },
    {
      path: '/evaluation',
      name: 'evaluation',
      component: () => import('./views/Evaluation.vue')
    },
    {
      path: '/eval-result',
      name: 'eval-result',
      component: () => import('./views/Result.vue')
    },
    {
      path: '/user-center',
      name: 'user-center',
      component: () => import('./views/User.vue')
    },
    {
      path: '/featured',
      name: 'featured',
      component: () => import('./views/Featured.vue')
    },
    {
      path: '/fund',
      name: 'fund',
      component: () => import('./views/Fund.vue')
    },
    {
      path: '*',
      name: '404',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})
